import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_vm.loadingPrint ? _c('div', {
    staticClass: "print-spin"
  }, [_c('a-spin', {
    attrs: {
      "tip": "打印生成中..."
    }
  })], 1) : _vm._e(), _c('a-card', {
    attrs: {
      "title": _vm.cardTitle,
      "size": "small",
      "bodyStyle": {
        padding: '1px'
      }
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), (_vm.$route.query.type == 3 || _vm.$route.query.type == 4) && _vm.formObject.detail.reimburseStatus === 2 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPrint
    }
  }, [_vm._v(" 打印 ")]) : _vm._e()], 1), _c('a-row', [_c('a-col', {
    staticClass: "card-left disabled-cursor",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "travel-title"
  }, [_c('strong', [_vm._v("差旅费用报销单")])]), _c('div', {
    staticClass: "disabled-events",
    style: {
      minWidth: '1400px'
    }
  }, [_c('a-row', {
    staticClass: "single-head"
  }, [_c('a-col', {
    attrs: {
      "span": 6
    }
  }), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('strong', [_vm._v("部门：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.organName) + " ")]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('strong', [_vm._v("报销日期：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.applyDate) + " ")]), _c('a-col', {
    attrs: {
      "span": 6
    }
  })], 1), _c('table', {
    staticClass: "single-table"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("出差人")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.userName) + " ")]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("出差事由")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.reason) + " ")])]), _c('tr', [_c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("起点")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("终点")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("交通")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("出差补助")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("其他费用金额")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("合计")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("日期")])]), _c('td', [_c('strong', [_vm._v("地点")])]), _c('td', [_c('strong', [_vm._v("日期")])]), _c('td', [_c('strong', [_vm._v("地点")])]), _c('td', [_c('strong', [_vm._v("工具")])]), _c('td', [_c('strong', [_vm._v("金额")])]), _c('td', [_c('strong', [_vm._v("人数")])]), _c('td', [_c('strong', [_vm._v("天数")])]), _c('td', [_c('strong', [_vm._v("补助标准")])]), _c('td', [_c('strong', [_vm._v("金额")])]), _c('td', [_c('strong', [_vm._v("招待费")])]), _c('td', [_c('strong', [_vm._v("场地费")])]), _c('td', [_c('strong', [_vm._v("食宿费")])]), _c('td', [_c('strong', [_vm._v("保险费")])]), _c('td', [_c('strong', [_vm._v("其他费用")])])]), _vm._l(_vm.formObject.detail.matterList, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.startdate))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.startplace))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.enddate))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.endplace))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.traffictool))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.trafficmoney))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.peoplenum))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.daynum))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.subsidystandard))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.subsidymoney))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.servefee))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.sitefee))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.roomboardfee))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.insurancefee))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.waterfee))]), _c('td', {
      staticClass: "txt-input"
    }, [_vm._v(_vm._s(item.mattertotal))])]);
  }), _c('tr', [_c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("合计")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.trafficMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.businessUser) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.evectionDay) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.evectionStandard) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.evectionMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.entertainMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.fieldMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.foodMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.insuranceMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.waterMoney) + " ")])]), _c('td', {
    staticClass: "txt-input"
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.detail.mattertotalMoney) + " ")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("报销总额")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("人民币（大写）：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.totalAmountBig) + " ")]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("￥：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.totalAmount) + " ")]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("预支旅费：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.advanceFee) + " ")]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("领款人：")]), _vm._v(" " + _vm._s(_vm.formObject.detail.payeeUser) + " ")])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "16"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("部门(年级)负责人：")]), _vm.formObject.director ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.director.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.director ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.director.auditOpinion) + " ")]) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("分管领导：")]), _vm.formObject.school ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.school.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.school ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.school.auditOpinion) + " ")]) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("财务审核：")]), _vm.formObject.finance ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.finance.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.finance ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.finance.auditOpinion) + " ")]) : _vm._e()])])], 1), _c('br'), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("财务总监：")]), _vm.formObject.cfo ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.cfo.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.cfo ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.cfo.auditOpinion) + " ")]) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("校长：")]), _vm.formObject.principal ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.principal.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.principal ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.principal.auditOpinion) + " ")]) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_c('strong', [_vm._v("理事长：")]), _vm.formObject.chairman ? _c('img', {
    attrs: {
      "height": "60",
      "src": "".concat(_vm.config.baseUrl).concat(_vm.formObject.chairman.sign)
    }
  }) : _vm._e()]), _c('div', [_c('strong', [_vm._v("审核意见：")]), _vm.formObject.chairman ? _c('span', [_vm._v(" " + _vm._s(_vm.formObject.chairman.auditOpinion) + " ")]) : _vm._e()])])], 1)], 1)])], 2)]), _c('a-form-model-item', {
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "label": "附件",
      "label-col": {
        span: 1
      },
      "wrapper-col": {
        span: 23
      }
    }
  }, [_c('a-list', {
    attrs: {
      "data-source": _vm.formObject.detail.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filePath),
            "download": item.fileName
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.fileName) + " ")])]), _c('div', [_vm._v(_vm._s(item.createTime))])], 1);
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "sliderbar-container"
  }, [_c('div', {
    staticClass: "sliderbar-off",
    on: {
      "click": function click($event) {
        return _vm.onSliderbar();
      }
    }
  }, [_c('a-icon', {
    attrs: {
      "type": _vm.sliderbar ? 'double-right' : 'double-left'
    }
  }), _vm._v(" 流转记录 ")], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sliderbar,
      expression: "sliderbar"
    }],
    staticClass: "sliderbar-on fadeInRight"
  }, [_c('a-card', {
    attrs: {
      "title": "审核流转记录",
      "bordered": false,
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.$route.query.type == 2 ? 'steps-content' : 'steps-content steps-content-view'
  }, [_vm.flowList.length == 0 ? _c('div', {
    style: {
      textAlign: 'center'
    }
  }, [_c('a-spin')], 1) : _c('a-timeline', _vm._l(_vm.flowList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": _vm.colorItem[item.auditStatus]
      }
    }, [_c('div', {
      staticClass: "timeline-title",
      attrs: {
        "title": item.appendName
      }
    }, [_vm._v(" " + _vm._s(item.appendName || '') + " ")]), _c('a-card', {
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [_c('div', [_vm._v(" " + _vm._s(index === 0 ? '创建人' : '审核人') + "：" + _vm._s(item.userName) + " "), item.organName ? _c('a-tag', {
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1), _c('div', [_vm._v(" " + _vm._s(index === 0 ? '创建时间' : '审核时间') + "：" + _vm._s(item.auditDate) + " ")]), item.auditStatus === 0 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v("通　过")])], 1) : _vm._e(), item.auditStatus === 1 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v("不通过")])], 1) : _vm._e(), item.auditStatus === 2 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v("待审核")])], 1) : _vm._e(), item.auditStatus === 3 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-orange"
    }, [_vm._v("驳　回")])], 1) : _vm._e(), (item.auditStatus === 0 || item.auditStatus === 1 || item.auditStatus === 3) && index != 0 ? _c('div', {
      staticClass: "timeline-opinion",
      attrs: {
        "title": item.auditOpinion
      }
    }, [_vm._v(" 审核意见：" + _vm._s(item.auditOpinion || '') + " ")]) : _vm._e()])], 1);
  }), 1)], 1), _vm.$route.query.type == 2 ? _c('div', {
    staticClass: "steps-form"
  }, [_c('a-divider'), _c('a-form-model', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditFormObj,
      "rules": _vm.rules,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "审核结果",
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    on: {
      "change": _vm.auditStatusChange
    },
    model: {
      value: _vm.auditFormObj.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "auditStatus", $$v);
      },
      expression: "auditFormObj.auditStatus"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("通过")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("不通过")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("驳回")])], 1)], 1), _vm.auditFormObj.auditStatus === 3 ? _c('a-form-model-item', {
    attrs: {
      "label": "驳回节点",
      "prop": "node"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择驳回节点"
    },
    on: {
      "select": _vm.auditNodeSelect
    },
    model: {
      value: _vm.auditFormObj.node,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "node", $$v);
      },
      expression: "auditFormObj.node"
    }
  }, _vm._l(_vm.nodeList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.id,
        "dataItem": item
      }
    }, [_vm._v(" " + _vm._s(item.appendName) + " ")]);
  }), 1)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "label": "审核意见",
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入审核意见",
      "max-length": 201,
      "rows": 5
    },
    model: {
      value: _vm.auditFormObj.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "auditOpinion", $$v);
      },
      expression: "auditFormObj.auditOpinion"
    }
  })], 1), _c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "wrapper-col": {
        span: 18,
        offset: 5
      }
    }
  }, [_c('a-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" 提交 ")])], 1)], 1)], 1) : _vm._e()])], 1)]), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "printTable"
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.printSrc,
      "seamless": "",
      "id": "printFrame"
    }
  })])], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };